import React, { useRef, useEffect } from 'react';
import './AudioSlider.scss';

function AudioSlider({ percentage = 0, onChange }) {
  const rangeRef = useRef();
  const sliderThumbRef = useRef();
  const sliderFillRef = useRef();

  useEffect(() => {
    if (sliderThumbRef.current && sliderFillRef.current) {
      sliderThumbRef.current.style.left = `${percentage}%`;
      sliderFillRef.current.style.width = `${percentage}%`;
    }
  }, [percentage]);

  return (
    <>
      <label
        htmlFor="range-slider-audio__input"
        className="label__audio-control sr-only"
      >
        Progress Bar
      </label>
      <div className={`slider-progress-bar__wrapper`}>
        {/* input is visually hidden */}
        <input
          name="Progress bar"
          className={`audio_progress_bar`}
          type="range"
          id="range-slider-audio__input"
          ref={rangeRef}
          value={percentage}
          min="0"
          max="100"
          onChange={onChange}
        />
        {/* styled elements that mimic a range input */}
        <div className="custom-track" aria-hidden="true">
          <span ref={sliderFillRef} className="custom-fill"></span>
          <span ref={sliderThumbRef} className="custom-thumb"></span>
        </div>
      </div>
    </>
  );
}

export default AudioSlider;
